/**
 * Provider for `queryParams`
 * @module
 */
var BrowserSource = require('core/utils/browser');

/**
 * @type {DataProvider}
 */
module.exports = {
  provides: 'queryParams',

  getter: [
    /**
     * @return {Array}
     */
    function() {
      return BrowserSource.getQueryParams();
    },
  ],
};
